export default __webpack_public_path__ + "media/titles/title_6_locale_es-2c647fbe.png";